/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum permissionSystemRole {
    ROLE_ONVIV_CSR_LIMITED = 'role:onviv_csr_limited',
    ROLE_ONVIV_CSR_ADMIN = 'role:onviv_csr_admin',
    ROLE_ONVIV_SUPER_ADMIN = 'role:onviv_super_admin',
    ROLE_TENANT_CSR_LIMITED = 'role:tenant_csr_limited',
    ROLE_TENANT_CSR_ADMIN = 'role:tenant_csr_admin',
}